import { createReducer } from '@reduxjs/toolkit';
import { loginToRedirectTenant } from '../redux';
import { actionCancelLeaveOrg, actionLeaveOrgError, actionLeaveOrgSuccess, actionSubmitLeaveOrg } from './actions';
import { ILeaveOrganizationSlice, LeaveOrgPhase } from './models';

export const getInitialState = (): ILeaveOrganizationSlice => ({
  hasSubmitLeaveOrg: false,
  hasLeftOrg: false,
  hasError: false,
  phase: LeaveOrgPhase.default
});

export default createReducer(getInitialState(), builder =>
  builder
    .addCase(actionSubmitLeaveOrg, state => {
      state.hasSubmitLeaveOrg = true;
      state.hasError = false;
      state.phase = LeaveOrgPhase.hasSubmitLeaveOrg;
    })
    .addCase(actionLeaveOrgSuccess, state => {
      state.hasLeftOrg = true;
      state.hasError = false;
      state.phase = LeaveOrgPhase.leaveOrgSuccess;
    })
    .addCase(actionLeaveOrgError, state => {
      state.hasLeftOrg = false;
      state.hasError = true;
      state.hasSubmitLeaveOrg = false;
      state.phase = LeaveOrgPhase.leaveOrgFailure;
    })
    .addCase(actionCancelLeaveOrg, state => {
      state.phase = LeaveOrgPhase.default;
      loginToRedirectTenant();
    })
);
